import PlanejamentoContratoFormProponente from '../../../../produto/spa/planejamento-contrato/form/passo-geral/PlanejamentoContratoFormProponente';

export default PlanejamentoContratoFormProponente;
